"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.seZones = void 0;
var seZones = exports.seZones = [{
  id: 'STOCKHOLM',
  name: 'Stockholm',
  country: 'SE',
  cornerNW: {
    latitude: 59.4046,
    longitude: 17.8219
  },
  cornerSE: {
    latitude: 59.2376,
    longitude: 18.1939
  },
  subZones: [{
    name: 'Stockholm Gamla Stan',
    zipcodes: {
      11120: {
        label: '11120'
      }
    }
  }, {
    name: 'Stockholm Norrmalm',
    zipcodes: {
      11336: {
        label: '11336'
      }
    }
  }, {
    name: 'Stockholm Södermalm',
    zipcodes: {
      11521: {
        label: '11521'
      }
    }
  }, {
    name: 'Stockholm Östermalm',
    zipcodes: {
      12032: {
        label: '12032'
      }
    }
  }]
}];